<div class="form-group items col-sm-12" *ngIf="rows" [ngClass]="{'tableauRefonte': isEcofact}">
    <div class="champ form-group">Log modification</div>
    <ngx-datatable #myTable class="material" style="height:275px;" [rows]="rows || []" [columnMode]="'force'"
        [headerHeight]="isEcofact ? '35': '50'" [footerHeight]="0" [rowHeight]="'auto'" [messages]="{emptyMessage: message}">

        <ngx-datatable-column name="User">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Nom </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong" *ngIf="row.user"> {{(row.user.prenom || '') + ' ' + row.user.nom}} </div>
                <div class="strong" *ngIf="!row.user"> - </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Date" prop="date">
            <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Date </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong"> {{ value.slice(0, -9) }} </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Heure" prop="heure">
            <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Heure </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong"> {{value}} </div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>
<div class="form-group items col-sm-12" *ngIf="logModifEtendu && logModifEtendu.derniereModification && logModifEtendu.derniereModification.id > 0">
    <mat-divider></mat-divider>
    <div class="champ form-group">Synthèse</div>
    <div class="col-sm-12">
        <label class="col-sm-6 champ" style="padding:0px" *ngIf="logModifEtendu.derniereModification && logModifEtendu.derniereModification.date"> Dernière modif. faite le :</label>
        <span class="col-sm-6" style="padding-right: 0px" *ngIf="logModifEtendu.derniereModification && logModifEtendu.derniereModification.date">{{logModifEtendu.derniereModification.date.slice(0, -9)}} {{logModifEtendu.derniereModification.heure}}</span>
    </div>
    <div class="col-sm-12">
        <label class="col-sm-6 champ" style="padding:0px" *ngIf="logModifEtendu.derniereModification  && logModifEtendu.derniereModification.user"> Par :</label>
        <span class="col-sm-6" style="padding-right: 0px" *ngIf="logModifEtendu.derniereModification  && logModifEtendu.derniereModification.user">{{(logModifEtendu.derniereModification.user.prenom || '') + ' ' + logModifEtendu.derniereModification.user.nom}}</span>
    </div>
    <div class="col-sm-12">
        <label class="col-sm-6 champ" style="padding:0px" *ngIf="logModifEtendu.validation  && logModifEtendu.validation.date"> Validation logistique faite le :</label>
        <span class="col-sm-6" style="padding-right: 0px" *ngIf="logModifEtendu.validation  && logModifEtendu.validation.date">{{logModifEtendu.validation.date.slice(0, -9)}} {{logModifEtendu.validation.heure}}</span>
    </div>
    <div class="col-sm-12">
        <label class="col-sm-6 champ" style="padding:0px" *ngIf="logModifEtendu.validation && logModifEtendu.validation.user"> Par :</label>
        <span class="col-sm-6" style="padding-right: 0px" *ngIf="logModifEtendu.validation  && logModifEtendu.validation.user">{{(logModifEtendu.validation.user.prenom || '') + ' ' + logModifEtendu.validation.user.nom}}</span>
    </div>
</div>

<div class="form-group items col-sm-12" *ngIf="logChorus">
    <ngx-datatable #myTable class="material" style="height:275px;" [rows]="logChorus || []" [columnMode]="'force'"
        [headerHeight]="50" [footerHeight]="0" [rowHeight]="'auto'" [messages]="{emptyMessage: message}">

        <ngx-datatable-column name="Code">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Code </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong" >{{value}}</div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Description">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Déscription </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong" >{{value}}</div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Date" prop="date">
            <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Date </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong"> {{ value.slice(0, -9) }} </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Heure" prop="heure">
            <ng-template let-col="column" ngx-datatable-header-template let-allRowsSelected="allRowsSelected"
                let-selectFn="selectFn" let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Heure </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong"> {{value}} </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="ComplementStatut">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                let-sort="sortFn">
                <div class="tableheader" (click)="sort()">
                    <span class="uppercase"> Motif </span>
                    <div class=" col-sm-1 pull-right">
                        <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true" (click)="sort()"></i>
                        <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true" (click)="sort()"></i>
                    </div>
                </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                <div class="strong" >{{value}}</div>
            </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>
</div>